import { render, staticRenderFns } from "./tender-stages.vue?vue&type=template&id=413d61cc&"
import script from "./tender-stages.vue?vue&type=script&lang=js&"
export * from "./tender-stages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports